import { render, staticRenderFns } from "./like.vue?vue&type=template&id=d14cbd76"
import script from "./like.vue?vue&type=script&lang=ts"
export * from "./like.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports